import { Constants } from './../constants/constants';

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import Swal from 'sweetalert2/dist/sweetalert2.all.js';//CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

import { Alert } from 'selenium-webdriver';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  public isUserLoggedIn;
  public matricula;
  constructor(
    private http: HttpClient
  ) {
    //this.isUserLoggedIn = false;
    //alert("entra ");
    //localStorage.setItem('isLoggedIn', this.isUserLoggedIn);

  }

  setUserLoggedIn(infoLogin) {
    
    var btoaString = infoLogin.username + ':' + infoLogin.password;
    
    let url = Constants.BASE_URL + Constants.URL_LOGIN;
    //alert(btoaString);
    //alert(url);
    this.isUserLoggedIn = '1';
    sessionStorage.setItem('isLoggedIn', this.isUserLoggedIn);

    let httpHeaders = new HttpHeaders()
              .set('Authorization', 'Basic '+btoa(btoaString))
              .set('Content-Type', 'application/json'); 

    /*const httpOptions = {
      headers: headers_object
    };*/
    return this.http.post<any>(url, null,{headers:httpHeaders})
      .pipe(
        catchError(err => {
          //this.setUserLoggedOut();
          sessionStorage.clear();
          //alert(JSON.stringify(err));
          //console.log("lanza error");     
          //'Error Consulta Estados ',JSON.stringify(err),'error'     
          Swal.fire({
            title:'Error Login',
            text:'Verifique la informacion ingresada.',
            type: 'error',
            confirmButtonColor: '#127570'
          });
          return throwError(err);
        })
      )

  }
  getUserLoggedIn() {
    //return false;
    let respuesta = '';
    if(!sessionStorage.getItem('isLoggedIn') || sessionStorage.getItem('isLoggedIn')=='0'){
      respuesta = '0';
    }
    else{
      respuesta = '1';
    }

    return respuesta;
  }
  setUserLoggedOut() {
    //this.isUserLoggedIn = '0';
    //sessionStorage.setItem('isLoggedIn', this.isUserLoggedIn);
    sessionStorage.clear();
    location.reload();
  }

}
